import React, { useRef } from 'react';
import { steps } from '../data/site';
import { useGSAP, gsap, MOTION_OK } from '../lib/gsap';

// A linha acompanha o scroll e acende cada etapa quando chega nela:
// mostra que o caminho até a festa é curto e tem ordem.
const HowItWorks = () => {
  const scope = useRef(null);

  useGSAP(
    () => {
      gsap.matchMedia().add(MOTION_OK, () => {
        gsap.from('[data-step-line]', {
          scaleX: 0,
          transformOrigin: 'left center',
          ease: 'none',
          scrollTrigger: { trigger: '[data-steps]', start: 'top 80%', end: 'bottom 55%', scrub: 0.6 },
        });
        gsap.utils.toArray('[data-step]').forEach((step) => {
          gsap.from(step, { autoAlpha: 0, y: 20, scrollTrigger: { trigger: step, start: 'top 85%', once: true } });
        });
      });
    },
    { scope }
  );

  return (
    <section ref={scope} data-testid="how-it-works-section" className="px-4 py-20 md:px-8 md:py-28">
      <div className="mx-auto max-w-7xl">
        <h2 className="max-w-2xl font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl">Do primeiro contato à pista cheia.</h2>

        <div data-steps className="relative mt-14">
          <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-line md:block" aria-hidden="true" />
          <div data-step-line className="absolute left-0 right-0 top-[6px] hidden h-[3px] bg-ink/25 md:block" aria-hidden="true" />
          <ol className="grid gap-10 md:grid-cols-3 md:gap-10">
            {steps.map((step) => (
              <li key={step.title} data-step className="relative border-l-2 border-ink/25 pl-5 md:border-l-0 md:pl-0 md:pt-10">
                <span className="absolute left-0 top-0 hidden h-4 w-4 rounded-full border-[3px] border-ink/60 bg-page md:block" aria-hidden="true" />
                <h3 className="font-display text-2xl font-semibold tracking-tight">{step.title}</h3>
                <p className="mt-2 max-w-[36ch] text-lg leading-relaxed text-soft">{step.text}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
